import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { UserSearchDialogOptions, UserSearchResult } from "./usersearch-dialog";
import { UserSearchDialogComponent } from "./usersearch-dialog.component";


@Injectable()
export class UserSearchDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open User Search Dialog Service Call

    Open(options?: UserSearchDialogOptions): Observable<UserSearchResult> {
        const self = this;

        const openHandle = self.matDialog.open<UserSearchDialogComponent>(UserSearchDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Multpiple Pathway Programs User Search',
                MessageText: '',
                ...options,
            },
            maxWidth: '80%',
            minWidth: '80%',
            width: '80%',
            maxHeight: '40rem',
            minHeight: '40rem',
            height: '40rem',
        });

        return openHandle.afterClosed();
    }

    // #endregion
}